"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _quill = _interopRequireDefault(require("quill"));
var _defaultsDeep = _interopRequireDefault(require("lodash/defaultsDeep"));
var _DefaultOptions = _interopRequireDefault(require("./DefaultOptions"));
var _DisplaySize = require("./modules/DisplaySize");
var _Toolbar = require("./modules/Toolbar");
var _Resize = require("./modules/Resize");
var knownModules = {
  DisplaySize: _DisplaySize.DisplaySize,
  Toolbar: _Toolbar.Toolbar,
  Resize: _Resize.Resize
};

/*
no-invalid-this: "off" is justified because the way this object is created
is a bit different than a standard object.  this is essentially a plugin to quill,
so it needs it's own standardized API to create/destroy, etc.
*/

/* eslint no-invalid-this: "off" */
var ImageResize = exports.default = function ImageResize(quill, options) {
  var _this = this;
  if (options === void 0) {
    options = {};
  }
  this.initializeModules = function () {
    _this.removeModules();
    _this.modules = _this.moduleClasses.map(function (ModuleClass) {
      return new (knownModules[ModuleClass] || ModuleClass)(_this);
    });
    _this.modules.forEach(function (module) {
      module.onCreate();
    });
    _this.onUpdate();
  };
  this.onUpdate = function () {
    _this.repositionElements();
    _this.modules.forEach(function (module) {
      module.onUpdate();
    });
  };
  this.removeModules = function () {
    _this.modules.forEach(function (module) {
      module.onDestroy();
    });
    _this.modules = [];
  };
  this.handleClick = function (evt) {
    if (evt.target && evt.target.tagName && evt.target.tagName.toUpperCase() === 'IMG') {
      if (_this.img === evt.target) {
        // we are already focused on this image
        return;
      }
      if (_this.img) {
        // we were just focused on another image
        _this.hide();
      }
      // clicked on an image inside the editor
      _this.show(evt.target);
    } else if (_this.img) {
      // clicked on a non image
      _this.hide();
    }
  };
  this.handleScroll = function () {
    // Hide the overlay when the editor is scrolled,
    // otherwise image is no longer correctly aligned with overlay
    _this.hide();
  };
  this.show = function (img) {
    // keep track of this img element
    _this.img = img;
    _this.showOverlay();
    _this.initializeModules();
  };
  this.showOverlay = function () {
    // if quill is set to readOnly, don't show overlay
    if (_this.quill.options.readOnly) {
      return;
    }
    if (_this.overlay) {
      _this.hideOverlay();
    }
    _this.quill.setSelection(null);

    // prevent spurious text selection
    _this.setUserSelect('none');

    // listen for the image being deleted or moved
    document.addEventListener('keyup', _this.checkImage, true);
    _this.quill.root.addEventListener('input', _this.checkImage, true);

    // Create and add the overlay
    _this.overlay = document.createElement('div');
    Object.assign(_this.overlay.style, _this.options.overlayStyles);
    _this.quill.root.parentNode.appendChild(_this.overlay);
    _this.repositionElements();
  };
  this.hideOverlay = function () {
    if (!_this.overlay) {
      return;
    }

    // Remove the overlay
    _this.quill.root.parentNode.removeChild(_this.overlay);
    _this.overlay = undefined;

    // stop listening for image deletion or movement
    document.removeEventListener('keyup', _this.checkImage);
    _this.quill.root.removeEventListener('input', _this.checkImage);

    // reset user-select
    _this.setUserSelect('');
  };
  this.repositionElements = function () {
    if (!_this.overlay || !_this.img) {
      return;
    }

    // position the overlay over the image
    var parent = _this.quill.root.parentNode;
    var imgRect = _this.img.getBoundingClientRect();
    var containerRect = parent.getBoundingClientRect();
    Object.assign(_this.overlay.style, {
      left: imgRect.left - containerRect.left - 1 + parent.scrollLeft + "px",
      top: imgRect.top - containerRect.top + parent.scrollTop + "px",
      width: imgRect.width + "px",
      height: imgRect.height + "px"
    });
  };
  this.hide = function () {
    _this.hideOverlay();
    _this.removeModules();
    _this.img = undefined;
  };
  this.setUserSelect = function (value) {
    ['userSelect', 'mozUserSelect', 'webkitUserSelect', 'msUserSelect'].forEach(function (prop) {
      // set on contenteditable element and <html>
      _this.quill.root.style[prop] = value;
      document.documentElement.style[prop] = value;
    });
  };
  this.checkImage = function (evt) {
    if (_this.img) {
      if (evt.keyCode === 46 || evt.keyCode === 8) {
        (window.Quill || _quill.default).find(_this.img).deleteAt(0);
      }
      _this.hide();
    }
  };
  // save the quill reference and options
  this.quill = quill;

  // Apply the options to our defaults, and stash them for later
  // defaultsDeep doesn't do arrays as you'd expect, so we'll need to apply the classes array from options separately
  var moduleClasses = false;
  if (options.modules) {
    moduleClasses = options.modules.slice();
  }

  // Apply options to default options
  this.options = (0, _defaultsDeep.default)({}, options, _DefaultOptions.default);

  // (see above about moduleClasses)
  if (moduleClasses !== false) {
    this.options.modules = moduleClasses;
  }

  // respond to clicks inside the editor
  this.quill.root.addEventListener('click', this.handleClick, false);
  this.quill.root.addEventListener('mscontrolselect', this.handleClick, false); // IE 11 support
  this.quill.root.addEventListener('scroll', this.handleScroll, false);
  this.quill.root.parentNode.style.position = this.quill.root.parentNode.style.position || 'relative';

  // setup modules
  this.moduleClasses = this.options.modules;
  this.modules = [];
};
if (window.Quill) {
  // BEGIN allow image alignment styles
  var ImageFormatAttributesList = ['alt', 'height', 'width', 'style'];
  var BaseImageFormat = window.Quill.import('formats/image');
  var ImageFormat = /*#__PURE__*/function (_BaseImageFormat) {
    (0, _inheritsLoose2.default)(ImageFormat, _BaseImageFormat);
    function ImageFormat() {
      return _BaseImageFormat.apply(this, arguments) || this;
    }
    ImageFormat.formats = function formats(domNode) {
      return ImageFormatAttributesList.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    };
    var _proto = ImageFormat.prototype;
    _proto.format = function format(name, value) {
      if (ImageFormatAttributesList.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _BaseImageFormat.prototype.format.call(this, name, value);
      }
    };
    return ImageFormat;
  }(BaseImageFormat);
  window.Quill.register(ImageFormat, true);
  // END allow image alignment styles

  window.Quill.register('modules/imageResize', ImageResize);
}